module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-crisis-line.json
// module id = 495
// module chunks = 105471718392764